import * as Yup from "yup"
export const mainLeadFormSchemaNew = Yup.object({
  email: Yup.string()
    .email("Must be valid email id")
    .required("Please enter your email id"),
  mobile: Yup.string().required("Please enter your phone number"),
  Tentative_Fleet_Size: Yup.string().required("Please select fleet size"),
})
